// The server can't measure the screen, so it renders for a width guessed from
// the user agent (see detectDevice). The widths fall inside the same
// Responsive BREAKPOINTS ranges as real phones, tablets and desktops, so the
// server-rendered layout usually matches what the browser needs.
const PHONE_WIDTH = 375;
const TABLET_WIDTH = 820;
const DESKTOP_WIDTH = 1200;

export const selectFakeWidth = (state) => {
  const { phone, tablet, mobile } = state.responsive || {};
  if (tablet) return TABLET_WIDTH;
  if (phone || mobile) return PHONE_WIDTH;
  return DESKTOP_WIDTH;
};
